const counter = () => {

    const $counters = $(".js-about-counter"),
          duration = 5000;

    $counters.each(function(){
        counterAction( $(this) );
    });


    function counterAction($counter) {

        const value = parseInt( $counter.attr('data-number') ),
              speed = duration / value;

        let currentVal = 0,

        counterAction = function(){
            currentVal++;
            $counter.text( formatNumber(currentVal) );
        };

        for ( let i = 0; i < value; i++ ) {
            setTimeout( counterAction, speed * i );
        }

    }

    function formatNumber(num) {
        num = num.toString();
        const pattern = /(-?\d+)(\d{3})/;
        while (pattern.test(num))
            num = num.replace(pattern, "$1 $2");
        return num;
    }

}
export default counter;